var _rect, _rect2, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRoundPlus(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.2,
    y: 1.2,
    width: 46.6,
    height: 46.6,
    rx: 23.3,
    fill: "#2D2F30"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.2,
    y: 1.2,
    width: 46.6,
    height: 46.6,
    rx: 23.3,
    stroke: "#2D2F30",
    strokeWidth: 1.4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.3333 25.652V32.6666C23.3333 32.993 23.4454 33.2666 23.6696 33.4874C23.8938 33.7082 24.1715 33.8187 24.5029 33.8187C24.8343 33.8187 25.1111 33.7082 25.3333 33.4874C25.5556 33.2666 25.6667 32.993 25.6667 32.6666V25.652H32.8333C33.1639 25.652 33.441 25.5413 33.6646 25.3199C33.8882 25.0986 34 24.8243 34 24.497C34 24.1698 33.8882 23.8964 33.6646 23.677C33.441 23.4575 33.1639 23.3478 32.8333 23.3478H25.6667V16.3332C25.6667 16.0068 25.5546 15.7332 25.3304 15.5124C25.1062 15.2916 24.8285 15.1812 24.4971 15.1812C24.1657 15.1812 23.8889 15.2916 23.6667 15.5124C23.4444 15.7332 23.3333 16.0068 23.3333 16.3332V23.3478H16.1667C15.8361 23.3478 15.559 23.4585 15.3354 23.6799C15.1118 23.9012 15 24.1755 15 24.5028C15 24.83 15.1118 25.1034 15.3354 25.3228C15.559 25.5423 15.8361 25.652 16.1667 25.652H23.3333Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoundPlus);
export default __webpack_public_path__ + "static/media/round_plus.79ce41ad080dfce19a86e534a3517d31.svg";
export { ForwardRef as ReactComponent };